<template>
  <div id="Choos">
    <div class="header">
      <img src="@/assets/img/logosvg.svg" class="logo" />
      <div class="language">
         <languageTranslation></languageTranslation>
        <!-- <div class="flag">
          <img src="@/assets/img/flag.png" />
        </div>
        <div class="dow">
          <img src="@/assets/img/dow.png" />
        </div> -->
      </div>
      <div class="user">
        <img src="@/assets/img/user_fff.png" />
      </div>
    </div>
    <div class="title">{{$t('choos.title')}}</div>
    <div class="system">
      <!-- <img v-if="system == 1" src="@/assets/img/a.png" />
      <img v-if="system == 2" src="@/assets/img/i.png" /> -->
      <i
        v-if="system == 1"
        class="u-iconfont uicon-android-fill system_logo"
      ></i>
      <i v-else class="u-iconfont uicon-apple-fill system_logo"></i>
      {{ system == 1 ? $t('choos.android') : $t('choos.ios') }} 
    </div>
    <div class="system_ul" 	  style="display: flex;align-items: center;justify-content: center;width: auto;">
      <div
        @click="oks(val, key)"
        :class="isshow == key ? 'system_li mr' : 'system_li'"
        v-for="(val, key) in list"
        :key="key"
        	style="flex: 1;max-width: 400px;"
      >
        <div class="top">
          <div class="top_left">
            <div class="top_l_t">{{ val.name }}</div>
            <div class="top_l_b">
              {{$t('choos.monitor')}} {{ val.equipment }} {{ val.equipment > 1 ? $t("choos.devices") : $t("choos.device") }}
            </div>
          </div>
          <div class="top_right">
            <b
              ><span
                style="
                  font-size: 15px;
                  font-family: Noto Sans;
                  margin-right: 3px;
                "
                >{{ $t('$') }}</span
              >{{
                val.package_prices.find((item) => item.id === ida)
                  ? val.package_prices.find((item) => item.id === ida)
                      .price_per_month
                  : val.name === $t("Premium")
                  ? val.package_prices[2].price_per_month
                  : val.package_prices[0].price_per_month
              }}</b
            >
            <div>
              <s
                >{{ $t('$') }}{{
                  val.package_prices.find((item) => item.id === ida)
                    ? val.package_prices.find((item) => item.id === ida)
                        .del_price_month
                    : val.name === $t("Premium")
                    ? val.package_prices[2].del_price_month
                    : val.package_prices[0].del_price_month
                }}</s
              >
              <span>/{{$t('choos.month')}}</span>
            </div>
          </div>
        </div>
        <div class="option">
          <div
            class="option_o"
            v-for="(val1, key1) in val.package_prices"
            :key="key1"
            style="display: flex"
            @click="ida = val1.id"
          >
            <div>
              <template v-if="isshow === key">
                <img v-if="ida == val1.id" src="@/assets/img/qdui.png" />
                <img v-else src="@/assets/img/qnodui.png" />
              </template>
              <template v-if="isshow !== key && key !== 0">
                <img v-if="key1 === 0" src="@/assets/img/qdui.png" />
                <img v-else src="@/assets/img/qnodui.png" />
              </template>
              <template v-if="isshow !== key && key === 0">
                <img v-if="key1 === 2" src="@/assets/img/qdui.png" />
                <img v-else src="@/assets/img/qnodui.png" />
              </template>
              <!-- <img v-if="ida == val1.id" src="@/assets/img/qdui.png" />
              <img v-else src="@/assets/img/qnodui.png" /> -->
              {{ val1.length }}-{{$t('choos.month')}} {{$t('choos.plan')}}
            </div>
            <div style="margin-left: 12px;">
              <b>{{ $t('$') }}{{ val1.price }}</b>
              <s>{{ $t('$') }}{{ val1.del_price }}</s>
            </div>
          </div>
          <!-- style="background-color: #eee; box-shadow: 0 2px 6px #eee" -->
          <div v-if="isshow != key" class="loginButton choosButton">
            {{$t('choos.buy')}}
          </div>
          <div
            v-if="isshow == key"
            @click="goShoppingCart()"
            class="loginButton choosButton"
          >
            {{$t('choos.buy')}}
          </div>
          <!-- <div @click="goShoppingCart()" class="loginButton choosButton">Buy Now</div> -->
        </div>
        <div class="content">
          <div v-for="(val2, key2) in val.ability_list" :key="key2">
            <img v-if="val2.checked" src="@/assets/img/dui.png" />
            <img v-if="!val2.checked" src="@/assets/img/dui2.png" />
            <span style="width: 56%; display: inline-block">{{
              val2.name
            }}</span>
          </div>
        </div>
        <div class="po_Most" v-if="val.is_tui">{{$t('choos.most')}}</div>
      </div>
    </div>
    <paddler ref="paddler" @paySuccess="paySuccess" />
  </div>
</template>

<script>
import { Ability, createVipOrder } from '@/api/user'
import paddler from './paddler/paddler'
export default {
  name: 'HelloWorld',
  inject: ['getheader'],
  components: {
    paddler
  },
  data () {
    return {
      isshow: 0,
      list: [],
      system: this.$route.params.type,
      ida: null,
      msg: '',
      val: {}
    }
  },
  mounted () {
    this.getlist()
  },
  methods: {
    paySuccess () {
      // this.$notify({
      //   title: '支付成功',
      //   message: '你已成功支付,即将跳转到绑定设备页面,走绑定流程',
      //   type: 'success'
      // })
      this.$router.push({ name: 'Guidance' })
      this.getheader('add')
    },
    getlist () {
      Ability({ type: this.system }).then((adj) => {
        console.log(adj)
        this.list = adj.data
        this.val = adj.data[0]
        // this.ida = adj.data[0].package_prices.at(-1).id
        // this.ida = adj.data[0].package_prices[0].id
        this.ida = adj.data[0].package_prices.find((item) => {
          return item.length === 12
        }).id
      })
    },
    oks (val, key) {
      this.val = val
      if (this.isshow !== key) {
        this.isshow = key
        // this.ida = val.package_prices[0].id
        // this.ida = val.package_prices.at(-1).id
        if (val.name ===  this.$t("Premium")) {
          this.ida = val.package_prices.find((item) => {
            return item.length === 12
          }).id
        } else {
          this.ida = val.package_prices[0].id
        }
      }
    },
    goShoppingCart () {
      if (!this.ida) {
        return false
      }
      console.log(this.list, this.ida)
      let temp = this.list[this.isshow].package_prices.find(
        (item) => Number(item.id) === Number(this.ida)
      )
      let key = {
        name: this.val.name,
        order_price: temp.del_price,
        pay_price: temp.price,
        package_price_id: temp.id,
        type: this.system === 1 ? 1 : 2
      }
      createVipOrder(key).then(({ code, data, msg }) => {
        if (code !== 1) {
          this.$message(msg)
          return false
        }
        this.$refs.paddler.showEdit(data.id, temp.paddle_product_id)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.header {
  position: fixed;
  height: 60px;
  z-index: 99;
  background: #000927;
  width: 100%;
  top: 0;
}
.header .logo {
  float: left;
  height: 20px;
  margin: 20px;
}
.header .language {
  float: right;
  margin: 20px;
  height: 20px;
  overflow: hidden;
}
.header .language .flag {
  border-radius: 8px;
}
.header .language .dow,
.header .language .flag {
  width: 16px;
  height: 16px;
  overflow: hidden;
  float: left;
  position: relative;
  margin: 2px;
}
.header .language img {
  width: 100%;
  height: 100%;
  top: 0;
  position: absolute;
  left: 0;
}
.header .user {
  float: right;
  margin: 18px 35px 0 0;
  height: 24px;
  width: 24px;
  overflow: hidden;
}
.header .user img {
  float: left;
  height: 24px;
  width: 24px;
}
#Choos {
  padding-top: 60px;
}
#Choos .title {
  width: 100%;
  height: 80px;
  line-height: 80px;
  font-size: 24px;
  font-weight: 700;
  text-align: center;
}
#Choos .system {
  height: 36px;
  width: 178px;
  margin: 0 auto;
  border-radius: 8px;
  border: 1px solid #d5d7db;
  text-align: center;
  font-size: 14px;
  line-height: 36px;
}
#Choos .system .system_logo {
  float: left;
  margin: 10px 0 0 10px;
  font-size: 20px;
}
.system_ul {
  margin: 40px auto 0;
  width: 1110px;
  overflow: hidden;
  padding-bottom: 70px;
}
.system_li {
  float: left;
  width: 336px;
  margin: 30px 0 20px 25px;
  background: #fff;
  border-radius: 12px;
  position: relative;
}
.system_li.mr {
  width: 360px;
  margin: 0 0 0 25px;
  padding: 30px 0 20px;
  border: 1px solid #00eec3;
  -webkit-box-shadow: 0 4px 16px -4px rgba(122, 138, 153, 0.4);
  box-shadow: 0 4px 16px -4px rgba(122, 138, 153, 0.4);
}
.system_li .top {
  height: 46px;
  width: 100%;
  overflow: hidden;
  padding: 25px 0;
  text-align: left;
}
.top_left {
  float: left;
  text-indent: 25px;
}
.top_l_t {
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 1px;
}
.top_l_b {
  font-size: 13px;
  color: #808080;
}
.top_right {
  float: right;
  line-height: 46px;
  /* font-size: 32px; */
  font-size: 22px;
  margin-right: 15px;
  display: flex;
}
.top_right div {
  font-size: 15px;
  display: flex;
  color: #9f9f9f;
  align-items: center;
}
.top_right s {
  font-size: 15px;
  color: #9f9f9f;
  line-height: 50px;
}
.option {
  border-top: 1px solid #e1e3e6;
  border-bottom: 1px solid #e1e3e6;
}
.option_o {
  font-size: 14px;
  line-height: 20px;
  margin-top: 20px;
  text-align: left;
  color: #45484d;
}
.option_o s {
  color: #9f9f9f;
}
.option_o img {
  width: 20px;
  height: 20px;
  float: left;
  margin-left: 40px;
  margin-right: 10px;
}
.choosButton {
  width: 270px;
  height: 40px;
  line-height: 40px;
  margin-top: 30px;
  margin-bottom: 30px;
  font-size: 15px;
}
.content {
  overflow: hidden;
  padding: 10px 0 30px;
  color: #45484d;
}
.content div {
  width: 50%;
  float: left;
  margin-top: 14px;
  line-height: 20px;
  font-size: 12px;
  display: flex;
  align-items: center;
}
.content div div {
  margin-top: 0;
}
.content div img {
  width: 16px;
  float: left;
  margin: 0 4px 0 16px;
}
.po_Most {
  display: block;
  position: absolute;
  top: 0;
  right: 0;
  padding: 0 12px;
  height: 26px;
  line-height: 26px;
  background: rgba(0, 238, 195, 0.2);
  border-radius: 0 9px 0 12px;
  font-size: 12px;
  color: #00d6b0;
  font-weight: 400;
}
.system_li.mr .top_l_t {
  font-size: 20px;
}
.system_li.mr .top_right {
  font-size: 32px;
}
.system_li.mr .top {
  padding: 15px 0 35px;
}
</style>



// WEBPACK FOOTER //
// src/components/Choos.vue